// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, TextFieldProps } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
  label: string;
  status?: boolean;
  className?: string;
};

export default function RHFDatePicker({ name, label, status, value, className }: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            disabled={status}
            label={label}
            value={field.value && new Date(field.value) ? new Date(field.value) : value}
            onChange={(newValue) => {
              field.onChange(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                fullWidth
                error={!!error}
                helperText={error?.message}
                className={className}
              />
            )}
          />
        </LocalizationProvider>
      )}
    />
  );
}
